import { Link } from 'react-router-dom'
import { getStudioHref } from '@/lib/hostRouting'
import { AuthHide } from '@/components/public/PublicCtas'
import { prefetchDemoPage } from '@/lib/prefetchDemo'
import { prefetchBookPage } from '@/lib/prefetchBook'
import { BRAND_LOGO } from '@/lib/brandAssets'

const LEARN_LINKS = [
  { to: '/#how-it-works', label: 'How it works' },
  { to: '/#what-it-models', label: 'What it models' },
  { to: '/#outputs', label: 'Outputs' },
  { to: '/#julio', label: 'Julio, the assistant' },
  { to: '/#about', label: 'About the team' },
  { to: '/#faq', label: 'FAQ' },
]

function FooterLink({ to, children, ...props }) {
  return (
    <Link to={to} className="transition-colors hover:text-foreground" {...props}>
      {children}
    </Link>
  )
}

export default function SiteFooter() {
  const loginHref = getStudioHref('/login')

  return (
    <footer className="mt-auto border-t border-border bg-card">
      <div className="mx-auto max-w-6xl px-5">
        <div className="grid gap-8 py-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2 text-base font-semibold tracking-tight">
              <img
                src={BRAND_LOGO.png}
                srcSet={BRAND_LOGO.pngSrcSet}
                sizes="26px"
                width="26"
                height="26"
                alt=""
                className="h-[26px] w-[26px] shrink-0 rounded object-cover"
              />
              retira.app
            </div>
            <p className="mt-3 max-w-sm text-[13px] leading-6 text-muted-foreground">
              Instant 401(k) plan modeling for advisors, consultants, and employers. Your census
              stays in your browser.
            </p>
          </div>

          <nav aria-label="Product">
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.15em] text-muted-foreground">
              Product
            </h4>
            <ul className="mt-3 space-y-2.5 text-[13px] text-muted-foreground">
              <li>
                <FooterLink to="/demo" onPointerEnter={prefetchDemoPage}>
                  401(k) calculator demo
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/book" onPointerEnter={prefetchBookPage}>
                  Book a call
                </FooterLink>
              </li>
              <AuthHide>
                <li>
                  <a href={loginHref} className="transition-colors hover:text-foreground">
                    Log in
                  </a>
                </li>
              </AuthHide>
            </ul>
          </nav>

          <nav aria-label="Learn">
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.15em] text-muted-foreground">
              Learn
            </h4>
            <ul className="mt-3 space-y-2.5 text-[13px] text-muted-foreground">
              {LEARN_LINKS.map(({ to, label }) => (
                <li key={to}><FooterLink to={to}>{label}</FooterLink></li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Company">
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.15em] text-muted-foreground">
              Company
            </h4>
            <ul className="mt-3 space-y-2.5 text-[13px] text-muted-foreground">
              <li><FooterLink to="/contact">Contact</FooterLink></li>
              <li><FooterLink to="/privacy">Privacy &amp; Terms</FooterLink></li>
            </ul>
          </nav>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-2 border-t border-border py-5 text-xs text-muted-foreground">
          <p>Results are illustrative only and are not legal, tax, or investment advice.</p>
          <p>
            © {new Date().getFullYear()} Retira LLC ·{' '}
            <a href="mailto:hello@retira.app" className="transition-colors hover:text-foreground">
              hello@retira.app
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}
